import React from "react";
import { Box, Button, Grid, Paper, Typography } from "@mui/material";
import DashboardLayout from "app/layout/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/layout/DashboardNavbar";
import HeaderPlacas from "./components/HeaderPlacas";
import TablePlacas from "./components/TablePlacas";
import { usePlacas } from "./hooks/usePlacas";
import { plateDate } from "./model/plateModel";
export default function Placas() {
  const state = usePlacas();
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Box sx={{ py: 3 }}>
        <Box sx={{ bgcolor: "#183b50", p: 3, borderRadius: "12px 12px 0 0" }}>
          <Typography sx={{ fontSize: "1.15rem", color: "#fff", fontWeight: 700 }}>
            Consulta de placas
          </Typography>
          <Typography sx={{ fontSize: ".8rem", color: "#d7e5ee" }}>
            Diagnóstico por comercio · Cerberus y Poseidon
          </Typography>
        </Box>
        <Paper sx={{ p: { xs: 2, md: 3 }, mb: 3, borderRadius: "0 0 12px 12px" }}>
          <HeaderPlacas state={state} />
        </Paper>
        <Grid container spacing={2} sx={{ mb: 2 }}>
          {[
            ["Comercios disponibles", state.stats.totalComercios, "#eef3f8", "#526579"],
            ["Consultas registradas", state.stats.totalConsultas, "#e8effa", "#365ba0"],
            ["Resultados recibidos", state.stats.resultados, "#e4f3e9", "#217346"],
          ].map(([label, count, bg, color]) => (
            <Grid item xs={12} sm={4} key={label}>
              <Paper sx={{ p: 2, bgcolor: bg, borderRadius: 2 }}>
                <Typography sx={{ fontSize: ".75rem", color }}>{label}</Typography>
                <Typography sx={{ fontSize: "1.5rem", fontWeight: 700, color }}>
                  {count.toLocaleString("es-CO")}
                </Typography>
              </Paper>
            </Grid>
          ))}
        </Grid>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            gap: 1,
            flexWrap: "wrap",
            mb: 2,
          }}
        >
          <Typography sx={{ fontSize: ".75rem", color: "#526579" }}>
            Catálogo actualizado: {plateDate(state.lastUpdated)} · Colombia (UTC−5)
          </Typography>
          <Button
            onClick={state.loadComercios}
            disabled={state.loadingComercios}
            sx={{ color: "#185a75" }}
          >
            {state.loadingComercios ? "Actualizando..." : "Actualizar comercios"}
          </Button>
        </Box>
        <TablePlacas state={state} />
      </Box>
    </DashboardLayout>
  );
}
